import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount',
)({
  component: () => <Outlet />,
})
